import defineCustomElement from '../../define-custom-element.js';

import TpChipSelect from './tp-chip-select.js';
import TpChipSportSelect from './tp-chip-sport-select.js';
import TpChoiceChip from './tp-choice-chip.js';
import TpSportChoiceChip from './tp-sport-choice-chip.js';

defineCustomElement('tp-choice-chip', TpChoiceChip);
defineCustomElement('tp-sport-choice-chip', TpSportChoiceChip);
defineCustomElement('tp-chip-select', TpChipSelect);
defineCustomElement('tp-chip-sport-select', TpChipSportSelect);

export {
  TpChipSelect,
  TpChipSportSelect,
  TpChoiceChip,
  TpSportChoiceChip
}
